// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorNotifications = (client) => ({
    /**
     * `GET /vendor/notifications`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListNotifications
     * @source packages/modules/b2c-core/src/api/vendor/notifications/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/notifications", { method: "GET", query, headers }),
});
//# sourceMappingURL=notifications.js.map